// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5fbdd558","977":"46c8b74f"}[chunkId] + ".chunk.js";
};